import React, {useContext, useEffect, useState} from "react";
import styled from "styled-components";
import {Header} from "@/components/Header";
import {Route, useHistory, useRouteMatch} from "react-router-dom";
import { Button, Input, InputGroup } from 'rsuite';
import {WidgetInfoContext} from "@/utils/widgetInfoProvider";
import { Plus } from '@rsuite/icons';

const Mobile = styled.div`
    display: flex;
    height: 100vh;
    background: #0E0F18;
    flex-direction: column;
`;


const Board = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 230px;
    background: #000000;
`;

const Block = styled.div`
    background: #141624;
    padding: 15px;
    margin-top: 1px;
    display: flex;
    justify-content: center;
`;

const Group = styled.div`
    flex: 1;
    padding: 0 15px;
`;

const styles = {
};

const config = [
    {
        title: 'Instagram',
        key: 'instagram'
    },
    {
        title: 'Youtube',
        key: 'youtube'
    },
    {
        title: 'Twitch',
        key: 'twitch'
    },
    {
        title: 'Facebook',
        key: 'facebook'
    },
    {
        title: 'Twitter',
        key: 'twitter'
    },
];

const initState = {
    instagram: '',
    youtube: '',
    twitch: '',
    facebook: '',
    twitter: '',
};

export default function SocialInfo() {
    const [values, setValues] = useState(initState);
    const history = useHistory();
    const { path } = useRouteMatch();
    const widgetContext = useContext(WidgetInfoContext);

    useEffect(() => {
        console.log(widgetContext);
    }, [widgetContext]);

    const handleInputChange = (value, e) => {
        const { name } = e.target;
        setValues({
            ...values,
            [name]: value,
        });
    };

    const handleClick = () => {
        widgetContext.setSocialInfo(values);
        history.push(`./editor`)
    };

    return (
        <Mobile>
            <Header title={"Select widget type"}/>

            <Group>
                {
                    config.map((it) => (
                        <InputGroup key={it.key} className="rs-theme-dark" inside size="lg" style={styles}>
                            <Input value={values[it.key]} name={it.key} onChange={handleInputChange} />
                            <InputGroup.Button>
                                <Plus/>
                            </InputGroup.Button>
                        </InputGroup>
                    ))
                }
            </Group>

            <div style={{
                display: 'flex',
                flexDirection: 'column',
                padding: '15px'}}>
                <Button appearance="primary" size="lg" onClick={handleClick}>Next step</Button>
            </div>
        </Mobile>
    );
}